import React from 'react'
import clsx from 'clsx'
import makeStyles from '@mui/styles/makeStyles'
import { CloseCircle, TickCircle } from 'iconsax-react'

const useStyles = makeStyles(theme => ({
  root: {
    textAlign: 'center',
    padding: 4,
    borderRadius: '1rem',
    transition: 'all .2s ease-in',

    '&:hover': {
      backgroundColor: '#dce9f5'
    }
  },

  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '1rem',
    fontSize: theme.size.sm,
    color: '#323436',
    cursor: 'pointer'
  },

  icon: {
    marginRight: '0.25rem',
    width: 'auto',
    borderRadius: '50%',
    boxSizing: 'border-box',
    fontSize: theme.size.base
  },

  iconNo: {
    color: 'red'
  },

  iconYes: {
    color: 'green'
  }
}))

const SmallButton = ({ children, positive, onClick, className }) => {
  const classes = useStyles()

  const Icon = positive ? TickCircle : CloseCircle

  return (
    <div className={clsx(classes.root, className)}>
      <span onClick={onClick} className={classes.button}>
        <Icon
          className={clsx(
            classes.icon,
            positive && classes.iconYes,
            !positive && classes.iconNo
          )}
        />
        {children}
      </span>
    </div>
  )
}

export default SmallButton
